import { render, staticRenderFns } from "./title_static.vue?vue&type=template&id=600fd215"
import script from "./title_static.vue?vue&type=script&lang=js"
export * from "./title_static.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports